import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';

import { classNames } from '@/utils';

import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import {
    ConversationMessageList,
    SocialInboxHeader
} from '@/components/pages/conversations/SocialInbox';
import { DirectMessageList } from '@/components/pages/conversations/SocialInbox/components/SocialInboxMessageList/DirectMessageList/DirectMessageList';

interface SocialInboxMessageListProps {
    className?: string;
}

export const SocialInboxMessageList = ({ className }: SocialInboxMessageListProps) => {
    const { currentSocialInbox } = useSocialInboxNavigation();

    return (
        <div
            className={classNames(
                `flex flex-col gap-5 overflow-hidden bg-white pr-4 dark:bg-icoDarkMode-deepBlack`,
                className,
                'pb-0'
            )}>
            <SocialInboxHeader />

            {currentSocialInbox === SOCIAL_INBOX_META.dm.key ? (
                <DirectMessageList />
            ) : (
                <ConversationMessageList />
            )}
        </div>
    );
};
